export default __webpack_public_path__ + "static/media/transfer-epoint-step6.6fa5dba9.png";